import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M7 8v8","key":"svg-1"}],["path",{"d":"M17 8v3a1 1 0 0 0 1 1h3","key":"svg-2"}],["path",{"d":"M21 8v8","key":"svg-3"}],["path",{"d":"M10 10v4a2 2 0 1 0 4 0m0 -4a2 2 0 0 0 -2 -2","key":"svg-4"}],["path",{"d":"M3 3l18 18","key":"svg-5"}]]

const IconError404Off = createReactComponent('outline', 'error-404-off', 'Error404Off', __iconNode);

export default IconError404Off;